/**
 * Entity type names the builder can target — the single source of truth.
 *
 * Previously declared locally in three modules
 * (`builderPlaceholder.ts`, `useBuilderSubject.ts`, `builderBackDestination.ts`);
 * hoisted here so they can never drift.
 */
export const AUTOMATION_ENTITY_TYPE = 'ahoy_event_automation';
export const SCHEDULED_AUTOMATION_ENTITY_TYPE = 'ahoy_scheduled_automation';
export const VALIDATION_RULE_ENTITY_TYPE = 'ahoy_validation_rule';
